import type { FaireProductEntity } from "../../entity_types/product";

export const p_vw4db65bzy: FaireProductEntity = {
  token: "p_vw4db65bzy",
  type: "product",
  name: "Wandering Heart Deck by Reyna  Biddy",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/cc9547a062b5aa494b018f0161bdbb35b0a86022b371748083178e7e38fac203.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6e7cfbf19b8d4a4138f69e7e32b9946e45cf427748d347d781fbcd2c7bbdcc5.jpeg",
    "https://cdn.faire.com/fastly/8b9426f04be667b0fbc0244c40244f1f59d97b3b2670491fbbc8971c835f77e7.jpeg",
    "https://cdn.faire.com/fastly/68fd78ba383049a887344d1992ac12e610737bf5170ddaba996d4e48adae8be4.jpeg",
    "https://cdn.faire.com/fastly/6f361a541f5d7712becc483967b2a1ecd5202ddbbede20083735bb82c3e4f981.jpeg",
    "https://cdn.faire.com/fastly/2e4ba755fcb597ca99936111dc43cde123cbe77947a221213f0b76d22a0c44bf.jpeg",
    "https://cdn.faire.com/fastly/47f9fee6ef0f6171788300b5a225bfe48ef78e01be4dadbc132dd328860e42a2.jpeg",
    "https://cdn.faire.com/fastly/abfdf8daa7ec4b66c419a57874e87deefa0b88cbf8353cbfb5202866cdf4fb13.jpeg",
    "https://cdn.faire.com/fastly/109e6ba1f2cc2cdab13f63445d24756a0f97b24bc8d6f1541c044ced83040412.jpeg",
    "https://cdn.faire.com/fastly/9bb85bf9c7c6a63574db7835782ed7e97d5660b78591ff521217a9b8f861b0e6.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "[AMP]\r\n\r\nVulnerability is life’s great teacher and the key to unlocking your own wandering heart. Your journey into clarity and truth starts here. With guidance from this enchanting new divination deck, it is your turn to step out of your comfort zone and into yourself.\r\n\r\nBest-selling poet Reyna Biddy has made a name for herself as a speaker of hard truths and an advocate of self-love, a journey that she continues with her intentionally designed 40-card deck and guidebook, Wandering Heart Deck.\r\n \r\nIn conjunction with captivating, inclusive illustrations by Brazilian artist Muri Lugh on themes of self-reflection, spiritual growth, and ancestral connection, Reyna’s gentle and poetic voice makes it beautiful and easy to tap into who you are, who you have been, and who you want to be.",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:39.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
